import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { Page } from "../../Page";
import { selectCurrentEventTaskTitle, selectCurrentEventTaskTitleEmpty, setTitle } from "../currentEventTask/currentEventTaskSlice";
import styles from './EventTaskWizard.module.css'
import { useEffect } from "react";
import { resetButtons, setBackButtonVisible, setPromptOkCancelOnBack } from "../menu/menuSlice";
import { setMessage } from "../messageBoxes/messageBoxSlice";
import { BackButton } from "../menu/BackButton";

export function NameEventTask() {
    const title = useAppSelector(selectCurrentEventTaskTitle)
    const titleEmpty = useAppSelector(selectCurrentEventTaskTitleEmpty)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setBackButtonVisible(true))
        dispatch(setPromptOkCancelOnBack(false))
        dispatch(setMessage('Cancel saving this Task?'))

      }, [dispatch]);
    return(
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                    <h2>PartyPlanner.</h2>
                        <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <div className={styles.bannerButton}>
                    <BackButton/>
                </div>
            </div>
            <div className={styles.header}>
            <h2>Welcome to Event Tasks!</h2>
            <br></br>
            <p>Our wizard will help you create a task for your party</p>
            <br></br>
            <h2>Please create a name for your task</h2>
            </div>
            <br></br>
            <label className={styles.label} htmlFor='txtTitle'>Title:</label>
            <input
                placeholder="Type name here"
                id='txtTitle'
                className={styles.textbox}
                aria-label='Set Title'
                value={title}
                onChange={(e) => dispatch(setTitle(e.target.value))}
            />
            <div className={styles.header}>
            {titleEmpty ? <p className={styles.validationMessage}>*Giving the task a name isn't necessary, click next to continue*</p> : null}
            </div>
            <br></br>
            <button className={styles.nextButton} onClick={() => {
                navigate('/ChooseEventTask')
            }}>Next</button>
        </Page>
    )
}